import { inject, Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { ScreenSessionResponse } from '../models/screen-session-response';
import { HttpAction } from '../studio-http-client/http-action.enum';
import { Observable } from 'rxjs';
import { PostResponse } from '../studio-http-client/post-response';

@Injectable({ providedIn: 'root' })
export class ScreenSessionService {
  apiService = inject(ApiService);

  getScreenSessions(userId: string, screenSessionId: string): Observable<ScreenSessionResponse> {
    const getURL = `api/Users/${userId}/ScreenSessions/${screenSessionId}`;
    return this.apiService.invokeLSApi<ScreenSessionResponse>(getURL, HttpAction.Get);
  }

  postScreenSession(userId: string, postData: ScreenSessionResponse): Observable<PostResponse> {
    const setURL = `api/Users/${userId}/ScreenSessions`;
    return this.apiService.invokeLSApi<PostResponse>(setURL, HttpAction.Post, postData);
  }

  updateScreenSession(
    userId: string,
    screenSessionId: string,
    expirationTime: string
  ): Observable<PostResponse> {
    const setURL = `api/Users/${userId}/ScreenSessions/${screenSessionId}`;
    return this.apiService.invokeLSApi<PostResponse>(setURL, HttpAction.Put, {
      expirationTime: expirationTime,
    });
  }
}
